<template>
    <v-layout row wrap>
        <v-flex xs3 class="pr-3">
            <v-card>
                <v-card-text>
                    <v-form v-model="valid" ref="form" @submit.prevent="submit" class="form--filters">
                        <v-layout row wrap>
                            <v-flex xs12>
                                <label class="filter-label">{{ $t('label.system') }}</label>
                                <v-select autocomplete v-bind:items="systems" v-model="form.system" :no-data-text="$t('message.warning.noData')"    ></v-select>
                            </v-flex>
                            <v-flex xs12>
                                <label class="filter-label">{{ $t('label.status') }}</label>
                                <v-checkbox v-model="form.statuses" color="secondary" :label="$t('type.status')[constants.STATUS_CREATED]" :value="constants.STATUS_CREATED"></v-checkbox>
                                <v-checkbox v-model="form.statuses" color="secondary" :label="$t('type.status')[constants.STATUS_CREATED_APPROVAL]" :value="constants.STATUS_CREATED_APPROVAL"></v-checkbox>
                                <v-checkbox v-model="form.statuses" color="secondary" :label="$t('type.status')[constants.STATUS_PLANNING]" :value="constants.STATUS_PLANNING"></v-checkbox>
                                <v-checkbox v-model="form.statuses" color="secondary" :label="$t('type.status')[constants.STATUS_PLANNING_APPROVAL]" :value="constants.STATUS_PLANNING_APPROVAL"></v-checkbox>
                                <v-checkbox v-model="form.statuses" color="secondary" :label="$t('type.status')[constants.STATUS_DELIVERY]" :value="constants.STATUS_DELIVERY"></v-checkbox>
                                <v-checkbox v-model="form.statuses" color="secondary" :label="$t('type.status')[constants.STATUS_DELIVERY_APPROVAL]" :value="constants.STATUS_DELIVERY_APPROVAL"></v-checkbox>
                                <v-checkbox v-model="form.statuses" color="secondary" :label="$t('type.status')[constants.STATUS_FINALIZING]" :value="constants.STATUS_FINALIZING"></v-checkbox>
                                <v-checkbox v-model="form.statuses" color="secondary" :label="$t('type.status')[constants.STATUS_DONE]" :value="constants.STATUS_DONE"></v-checkbox>
                                <v-checkbox v-model="form.statuses" color="secondary" :label="$t('type.status')[constants.STATUS_REJECTED]" :value="constants.STATUS_REJECTED"></v-checkbox>
                            </v-flex>
                            <v-flex xs12>
                                <label class="filter-label">{{ $t('label.flow') }}</label>
                                <v-select autocomplete v-bind:items="types" v-model="form.type" :no-data-text="$t('message.warning.noData')"></v-select>
                            </v-flex>
                            <v-flex xs12>
                                <label class="filter-label">{{ $t('label.creator') }}</label>
                                <v-select autocomplete v-bind:items="persons" v-model="form.creator" :no-data-text="$t('message.warning.noData')"></v-select>
                            </v-flex>
                            <v-flex xs12>
                                <label class="filter-label">{{ $t('label.requester') }}</label>
                                <v-select autocomplete v-bind:items="persons" v-model="form.requester" :no-data-text="$t('message.warning.noData')"></v-select>
                            </v-flex>
                            <v-flex xs12>
                                <label class="filter-label">{{ $t('label.owner') }}</label>
                                <v-select autocomplete v-bind:items="persons" v-model="form.owner" :no-data-text="$t('message.warning.noData')"></v-select>
                            </v-flex>
                            <v-flex xs12>
                                <label class="filter-label">{{ $t('label.contract') }}</label>
                                <v-select autocomplete v-bind:items="contracts" v-model="form.contract" :no-data-text="$t('message.warning.noData')"></v-select>
                            </v-flex>
                            <v-layout row xs12>
                                <v-flex xs4 >
                                    <label class="filter-label">{{ $t('label.from') }}</label>
                                    <app-menu-date-picker :model.sync="form.fromDate"></app-menu-date-picker>
                                </v-flex>

                                <v-flex xs4 offset-xs1 >
                                    <label class="filter-label">{{ $t('label.to') }}</label>
                                    <app-menu-date-picker :model.sync="form.toDate" :rules="formFinishRule"></app-menu-date-picker>
                                </v-flex>
                            </v-layout>
                            <v-flex xs12>
                                <v-checkbox v-model="form.rejections" color="secondary" :label="$t('label.houveDevolucoes')"></v-checkbox>
                            </v-flex>
                            <v-flex xs12>
                                <v-btn :disabled="paginating" :loading="processing" @click="search" color="primary" class="ma-0">
                                    {{ $t('label.search') }}
                                </v-btn>
                                <v-btn :disabled="searching || paginating" @click="clear" class="ma-0">
                                    {{ $t('label.clear') }}
                                </v-btn>
                            </v-flex>
                            <v-flex xs12>
                                <v-menu :close-on-content-click="false" offset-x class="ma-0">
                                    <v-btn slot="activator" class="ma-0">
                                        {{ $t('label.export') }}
                                    </v-btn>
                                    <v-list>
                                            <v-list-tile>
                                                <v-list-tile-content>
                                                    <v-btn :disabled="searching || paginating" :loading="processing" @click="createReport('pdf')" color="primary" class="ma-0">
                                                                PDF
                                                            </v-btn>
                                                </v-list-tile-content>
                                            </v-list-tile>
                                            <v-list-tile>
                                                <v-list-tile-content>
                                                    <v-btn :disabled="searching || paginating" :loading="processing" @click="createReport('csv')" color="primary" class="ma-0">
                                                                CSV
                                                            </v-btn>
                                                </v-list-tile-content>
                                            </v-list-tile>
                                        </v-list>
                                </v-menu>
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-flex>
        <v-flex xs9>
            <v-data-table :headers="headers" :items="items" :pagination.sync="pagination" :total-items="totalItems" :loading="paginating" :no-data-text="$t('message.warning.noData')" :rows-per-page-items="constants.componentOptions.rowsPerPageItems" :rows-per-page-text="$t('label.pagination')" class="elevation-1">
                <template slot="items" slot-scope="{item}">
                    <router-link :to="{ name: 'demandEdit', params: { id: item.id } }" tag="tr">

                        <td class="demand-code">{{ item.code }}</td>
                        <td class="system-acronym">{{ item.system.acronym }}</td>
                        <td class="situation-name">{{ item.status.name }}</td>
                        <td>{{ item.title }}</td>
                        <td>{{ item.estimatedTime}}</td>
                        <!-- <td><span v-if="item.deliveries.count > 0">{{ item.deliveries[0].plannedTime}}</span></td> -->
                        <!-- <td><span v-if="item.deliveries.count > 0">{{ item.deliveries[0].executedTime}}</span></td> -->
                        <td>{{ item.executedTime}}</td>
                    </router-link>
                </template>
            </v-data-table>
        </v-flex>
    </v-layout>
</template>

<script>
import api from '@/api';
import store from '@/store';
import constants from '@/helpers/constants';
import utilities from '@/helpers/utilities';
import validation from '@/helpers/validation';
import MenuDatePicker from '@/components/shared/MenuDatePicker';

export default {
    data() {
        return {
            constants,
            validation,
            valid: true,
            searching: false,
            exporting: false,
            paginating: false,

            systems: this.$store.getters.systemsValueText,
            persons: this.$store.getters.personsValueText,
            types: this.$store.getters.demandTypesValueText,
            contracts: this.$store.getters.contractsValueText,

            form: {
                system: null,
                creator: null,
                owner: null,
                requester: null,
                type: null,
                contract: null,
                statuses: [],
                rejections: null,
                fromDate: null,
                toDate: null,
            },
            formFinishRule: [
                () => this.form.toDate >= this.form.fromDate || this.$t('message.error.period'),
            ],

            pagination: {},
            totalItems: 0,
            items: [],
            headers: [
                {
                    text: this.$t('label.code'),
                    value: 'code',
                    align: 'left',
                },
                {
                    text: this.$t('label.system'),
                    value: 'system.acronym',
                    align: 'left',
                    sortable: false,
                },
                {
                    text: this.$t('label.status'),
                    value: 'status.id',
                    align: 'left',
                    sortable: false,
                },
                {
                    text: this.$t('label.name'),
                    value: 'title',
                    align: 'left',
                    sortable: false,
                },
                {
                    text: this.$t('label.estimatedQuantity'),
                    value: 'deliveries[0].plannedTime',
                    align: 'left',
                },
                {
                    text: this.$t('label.executedQuantity'),
                    value: 'deliveries[0].executedTime',
                    align: 'left',
                },
            ],

        };
    },

    watch: {
        pagination: {
            handler(newValue, oldValue) {
                Object.assign(this.form, newValue);
                if (oldValue.page !== undefined) this.searchWorker();
            },
            deep: true,
        },
    },

    computed: {
        processing() {
            return this.searching || this.exporting;
        },
    },

    methods: {
        clear() {
            this.form = {
                system: null,
                creator: null,
                owner: null,
                requester: null,
                type: null,
                contract: null,
                statuses: [],
                fromDate: null,
                toDate: null,
            };
        },
        async search() {
            if (!this.$refs.form.validate()) return;

            const pagination = Object.assign({}, this.pagination);
            pagination.page = 1;
            pagination.descending = true;
            this.pagination = pagination; // Don't call searchWorker. The Watcher will handle it
        },
        async searchWorker() {
            this.searching = true;
            const response = await api.demands.searchByFilter(this.form);
            this.searching = false;
            this.totalItems = response.data.output.total;
            this.items = response.data.output.result;
        },
        async createReport(reportType) {
            if (!this.$refs.form.validate()) return;
            this.exporting = true;
            const params = {
                system: this.form.system,
                creator: this.form.creator,
                owner: this.form.owner,
                requester: this.form.requester,
                type: this.form.type,
                contract: this.form.contract,
                statuses: this.form.statuses.length > 0 ? JSON.stringify(this.form.statuses) : null,
                fromDate: this.form.fromDate,
                toDate: this.form.toDate,
                rejections: this.form.rejections,
                reportType,
            };
            const reportName = `RelatorioDemandas_${utilities.toDateTime(Date.now())}.${reportType}`;
            this.ajaxDownload(`application/${reportType}`, reportName, params);
        },

        async ajaxDownload(type, name, params) {
            const xhr = new XMLHttpRequest();
            const url = process.env.API_URL;
            const reportUrl = '/reports/demands';
            const token = store.getters.profile.token;
            const self = this;

            xhr.open('POST', url + reportUrl, true);
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.setRequestHeader('Accept', type);
            xhr.setRequestHeader('Authorization', `Bearer ${token}`);
            xhr.responseType = 'arraybuffer';

            xhr.send(JSON.stringify(utilities.toPayload(params)));
            xhr.onprogress = this.callback;
            xhr.onload = function onload() {
                if (this.status === 200) {
                    const blob = new Blob([this.response], { type });
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = name;
                    link.click();
                    link.remove();
                }
            };
            xhr.onloadend = function onloadend() {
                self.exporting = false;
            };
        },
    },
    components: {
        appMenuDatePicker: MenuDatePicker,
    },

};
</script>



// WEBPACK FOOTER //
// src/components/demands/Report.vue